export const monitoringSortFieldsFetch = {
    requestInFlight: null as Promise<void> | null,
    lastAttemptToken: null as string | null,
};

const branchIdSortField = {
    name: 'branchId',
    order: 0,
    isActive: false,
    inSystem: false,
};

export function withBranchIdSortField(sortFieldsData: any) {
    if (!sortFieldsData) {
        return sortFieldsData;
    }

    const normalized = Array.isArray(sortFieldsData)
        ? {fields: sortFieldsData}
        : sortFieldsData;

    if (!normalized?.fields?.length) {
        return normalized;
    }

    const hasBranchId = normalized.fields.some((field: { name: string }) => field.name === 'branchId');
    if (hasBranchId) {
        return normalized;
    }

    const fields = [...normalized.fields].sort((a, b) => a.order - b.order);
    const campaignIndex = fields.findIndex((field) => field.name === 'campaignFullName');

    if (campaignIndex !== -1) {
        fields.splice(campaignIndex + 1, 0, {...branchIdSortField});
    } else {
        fields.push({...branchIdSortField});
    }

    return {
        ...normalized,
        fields: fields.map((field, index) => ({
            ...field,
            order: index + 1,
        })),
    };
}

export const withMonitoringBranchIdSortField = withBranchIdSortField;
export const withStatisticsBranchIdSortField = withBranchIdSortField;

export const statisticsSortFieldsFetch = {
    requestInFlight: null as Promise<void> | null,
    lastAttemptToken: null as string | null,
};

export const qualityControlSortFieldsFetch = {
    requestInFlight: null as Promise<void> | null,
    lastAttemptToken: null as string | null,
};

export function resetAllSortFieldsFetchState() {
    monitoringSortFieldsFetch.requestInFlight = null;
    monitoringSortFieldsFetch.lastAttemptToken = null;
    statisticsSortFieldsFetch.requestInFlight = null;
    statisticsSortFieldsFetch.lastAttemptToken = null;
    qualityControlSortFieldsFetch.requestInFlight = null;
    qualityControlSortFieldsFetch.lastAttemptToken = null;
}
